var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/StatusPanelLayout/StatusPanelLayout.tsx";
import { styled, InputBase, Select } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';
export var StatusPanelLayout = styled('div')(function (props) {
  return {
    display: 'flex',
    flexDirection: props.isDirectionCol ? 'column' : 'row',
    alignItems: 'flex-start',
    flexWrap: props.isDirectionCol ? 'nowrap' : 'wrap',
    minHeight: '46px',
    padding: '9px 12px 15px 12px',
    borderTop: '1px solid #E5E7F1',
    gap: '8px 4px',
    transition: 'transform .2s linear',
    transform: props.open ? 'translateY(0)' : 'translateY(100%)'
  };
});
export var SelectForm = styled(Select)(function (props) {
  return {
    input: {
      borderRadius: 4,
      border: '1px solid',
      fontSize: 16,
      marginLeft: 16,
      padding: '10px 18px 10px 12px',
      '&:focus': {
        borderRadius: 4
      }
    }
  };
});
export var SelectInput = withStyles(function (theme) {
  return createStyles({
    input: {
      borderRadius: 4,
      border: '1px solid',
      fontSize: 16,
      marginLeft: 16,
      padding: '10px 18px 10px 12px',
      '&:focus': {
        borderRadius: 4
      }
    }
  });
})(InputBase);